import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserInfoFormDataInput } from '../components/form-user-info/form-user-info.validation';

export type FormType = UserInfoFormDataInput;

export type UserRegisterFormState = {
  birthDate: string | null;
  accountId?: string;
} & Omit<FormType, 'birthDate'>;

const initialState: Partial<UserRegisterFormState> = {};

const userRegisterSlice = createSlice({
  name: 'recovery-account',
  initialState,
  reducers: {
    updateUserRegistration: (
      _,
      action: PayloadAction<Partial<UserRegisterFormState>>,
    ) => ({
      ...(action.payload as unknown as Partial<UserRegisterFormState>),
    }),
    clearUserRegistration: state => {
      state.address = '';
      state.birthDate = null;
      state.birthState = '';
      state.city = '';
      state.cityOfBirth = '';
      state.civilStatus = undefined;
      state.compliment = '';
      state.contactPhone = '';
      state.countryOfBirth = '';
      state.cpf = '';
      state.district = '';
      state.email = '';
      state.fatherName = '';
      state.fixedPhone = '';
      state.gender = undefined;
      state.instructionLevel = undefined;
      state.motherName = '';
      state.name = '';
      state.number = '';
      state.numberForErrands = '';
      state.profession = '';
      state.referencePoint = '';
      state.rg = '';
      state.state = '';
      state.zipCode = '';
    },
  },
});

export const { updateUserRegistration, clearUserRegistration } =
  userRegisterSlice.actions;
export default userRegisterSlice.reducer;
